<template>
    <div>
        <app-sub-title text="Filtros" />
        <b-row>
            <b-col cols="12" md="3" lg="2" >
                <app-form-text-input 
                    v-model="filters.code"
                    placeholder="Codigo"
                />
            </b-col>
            <b-col align-h="center" cols="12" md="5" lg="5">
                <app-autocomplete
                    placeholder="Cliente"
                    :items="clients"
                    v-model="selectClient"
                />
            </b-col>   
            <b-col align-h="center" cols="12" md="4" lg="5">
                <app-autocomplete
                    placeholder="Usuario creador"
                    :items="authors"
                    v-model="selectUser"
                />
            </b-col> 
            <b-col cols="12" lg="6">
                <b-row>
                    <b-col cols="12">
                        <h6>Fecha de creación</h6>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" lg="6">
                        <app-date-time-picker
                            id="creationDateFrom" 
                            placeholder="Desde" 
                            v-model="filters.creationDateFrom" 
                            :with-time="false"
                        />
                    </b-col>
                    <b-col cols="12" lg="6">
                        <app-date-time-picker 
                            id="creationDateTo" 
                            placeholder="Hasta" 
                            v-model="filters.creationDateTo" 
                            :with-time="false"
                        />
                    </b-col>
                </b-row>
            </b-col>
            <b-col cols="12" lg="6">
                <b-row>
                    <b-col cols="12">
                        <h6>Fecha de reunión</h6>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" lg="6">
                        <app-date-time-picker
                            id="meetingDateFrom" 
                            placeholder="Desde" 
                            v-model="filters.meetingDateFrom" 
                            :with-time="false"
                        />
                    </b-col>
                    <b-col cols="12" lg="6">
                        <app-date-time-picker 
                            id="meetingDateTo" 
                            placeholder="Hasta" 
                            v-model="filters.meetingDateTo" 
                            :with-time="false"
                        />
                    </b-col>
                </b-row>
            </b-col>
            <b-col cols="12" md="2" lg="1" offset-lg="10">
                <b-button variant="primary" class="btn-block" @click="$emit('filter', filters)"><i class="fa fa-filter"></i></b-button>
            </b-col>
            <b-col cols="12" md="2" lg="1">
                <b-button variant="secondary" class="btn-block"  @click="clearFilters"><i class="fa fa-times-circle"></i></b-button>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import DateTimePicker from "../../../../../UI/Controls/DateTimePicker/DateTimePicker.vue";
import Autocomplete from '../../../../../UI/Controls/AutocompleteV2/Autocomplete.vue';
import { mapGetters } from 'vuex';
export default {
    components: {
        appDateTimePicker: DateTimePicker,
        appAutocomplete: Autocomplete
    },
    props: {
        authors: {
            type: Array
        }
    },
    data(){
        return {
            filters: {
                code: '',
                name: '',
                meetingDateFrom: '',
                meetingDateTo: '',
                creationDateFrom: '',
                creationDateTo: '',
                clientId: '',
                reportedById: ''
            },
            selectClient: '',
            selectUser: ''
        }
    },
    computed: {
        ...mapGetters(['clients'])
    },
    watch:{
        selectClient(val){
            if(!val){
                this.filters.clientId= '';
                this.selectClient = '';
            }else{
                this.filters.clientId = val.id;
            }
        },
        selectUser(val){
            if(!val){
                this.filters.reportedById= '';
                this.selectUser = '';
            }else{
                this.filters.reportedById = val.id;
            }
        }
    },
    methods: {
        clearFilters(){
            this.selectClient= '';
            this.selectUser = '';
            Object.keys(this.filters).map(key => this.filters[key] = '');
            this.$emit('filter', null);
        }
    },
    created(){
        this.load('clients');
    }
}
</script>

